import { render, staticRenderFns } from "./orders-main.vue?vue&type=template&id=d735bac8&"
import script from "./orders-main.vue?vue&type=script&lang=js&"
export * from "./orders-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports